let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bo2dV")).then(() => parcelRequire('8YmLU'));